<template>
    <div id="app">
        <IndexHdm v-if="screen === 0"></IndexHdm>
        <Screen1 v-if="screen === 1"></Screen1>
        <Screen2 v-if="screen === 2"></Screen2>
        <Screen_final v-if="screen === 100"></Screen_final>
        <Screen3 v-if="screen === 3"></Screen3>
        <Screen4 v-if="screen === 4"></Screen4>
        <Screen5 v-if="screen === 5"></Screen5>
        <Screen6 v-if="screen === 6"></Screen6>
        <Screen7 v-if="screen === 7"></Screen7>
        <Screen8 v-if="screen === 8"></Screen8>
        <Screen9 v-if="screen === 9"></Screen9>
        <Screen10 v-if="screen === 10"></Screen10>
        <Screen11 v-if="screen === 11"></Screen11>
        <Screen12 v-if="screen === 12"></Screen12>
        <Screen13 v-if="screen === 13"></Screen13>
        <Screen14 v-if="screen === 14"></Screen14>
        <Screen15 v-if="screen === 15"></Screen15>
        <Screen16 v-if="screen === 16"></Screen16>
        <Screen17 v-if="screen === 17"></Screen17>
        <Screen18 v-if="screen === 18"></Screen18>
        <Screen19 v-if="screen === 19"></Screen19>
        <Screen20 v-if="screen === 20"></Screen20>
        <Screen21 v-if="screen === 21"></Screen21>
        <Screen22 v-if="screen === 22"></Screen22>
        <Screen23 v-if="screen === 23"></Screen23>
        <Screen24 v-if="screen === 24"></Screen24>
        <Screen25 v-if="screen === 25"></Screen25>
        <Screen26 v-if="screen === 26"></Screen26>
        <Screen27 v-if="screen === 27"></Screen27>
        <Screen28 v-if="screen === 28"></Screen28>
        <Screen29 v-if="screen === 29"></Screen29>
        <ManagePartitions v-if="screen === 30"></ManagePartitions>
        <MP_screen1 v-if="screen === 31"></MP_screen1>
        <MP_screen2 v-if="screen === 32"></MP_screen2>
        <MP_screen3 v-if="screen === 33"></MP_screen3>
        <MP_screen4 v-if="screen === 34"></MP_screen4>
        <MP_screen5 v-if="screen === 35"></MP_screen5>
        <MP_screen6 v-if="screen === 36"></MP_screen6>
        <MP_screen7 v-if="screen === 37"></MP_screen7>
        <MP_screen8 v-if="screen === 38"></MP_screen8>
        <MP_screen9 v-if="screen === 39"></MP_screen9>
        <MP_screen10 v-if="screen === 40"></MP_screen10>
        <MP_screen11 v-if="screen === 41"></MP_screen11>
        <MP_screen12 v-if="screen === 42"></MP_screen12>
        <MP_screen13 v-if="screen === 43"></MP_screen13>
        <MP_screen14 v-if="screen === 44"></MP_screen14>
        <MP_screen15 v-if="screen === 45"></MP_screen15>
        <MP_screen16 v-if="screen === 46"></MP_screen16>
        <MP_screen17 v-if="screen === 47"></MP_screen17>
        <MP_screen18 v-if="screen === 48"></MP_screen18>
        <MP_screen19 v-if="screen === 49"></MP_screen19>
        <MP_screen20 v-if="screen === 50"></MP_screen20>
        <MP_screen21 v-if="screen === 51"></MP_screen21>
        <MP_screen22 v-if="screen === 52"></MP_screen22>
        <MigrateDataOS v-if="screen === 53"></MigrateDataOS>
        <MD_screen1 v-if="screen === 54"></MD_screen1>
        <MD_screen2 v-if="screen === 55"></MD_screen2>
        <MD_screen3 v-if="screen === 56"></MD_screen3>
        <MD_screen4 v-if="screen === 57"></MD_screen4>
        <MD_screen5 v-if="screen === 58"></MD_screen5>
        <MD_screen6 v-if="screen === 59"></MD_screen6>
        <MD_screen7 v-if="screen === 60"></MD_screen7>
        <MD_screen8 v-if="screen === 61"></MD_screen8>
        <MD_screen9 v-if="screen === 62"></MD_screen9>
        <MD_screen10 v-if="screen === 63"></MD_screen10>
        <MD_screen11 v-if="screen === 64"></MD_screen11>
        <WS_screen1 v-if="screen === 65"></WS_screen1>
        <WS_screen2 v-if="screen === 66"></WS_screen2>
        <WS_screen3 v-if="screen === 67"></WS_screen3>
        <WS_screen4 v-if="screen === 68"></WS_screen4>
        <WS_screen5 v-if="screen === 69"></WS_screen5>
        <WS_screen6 v-if="screen === 70"></WS_screen6>
        <WS_screen7 v-if="screen === 71"></WS_screen7>
        <WS_screen8 v-if="screen === 72"></WS_screen8>
        <WS_screen9 v-if="screen === 73"></WS_screen9>
        <CD_screen1 v-if="screen === 74"></CD_screen1>
        <CD_screen2 v-if="screen === 75"></CD_screen2>
        <CD_screen3 v-if="screen === 76"></CD_screen3>
        <CD_screen4 v-if="screen === 77"></CD_screen4>
        <CD_screen5 v-if="screen === 78"></CD_screen5>
        <CD_screen6 v-if="screen === 79"></CD_screen6>
        <CD_screen7 v-if="screen === 80"></CD_screen7>
        <CD_screen8 v-if="screen === 81"></CD_screen8>
        <CD_screen9 v-if="screen === 82"></CD_screen9>
        <CD_screen10 v-if="screen === 83"></CD_screen10>
        <CD_screen11 v-if="screen === 84"></CD_screen11>
        <CD_screen12 v-if="screen === 85"></CD_screen12>
        <CD_screen13 v-if="screen === 86"></CD_screen13>
        <CD_screen14 v-if="screen === 87"></CD_screen14>
        <CD_screen15 v-if="screen === 88"></CD_screen15>
        <CD_screen16 v-if="screen === 89"></CD_screen16>
        <Screen1_1 v-if="screen === 90"></Screen1_1>
        <Screen23_1 v-if="screen === 91"></Screen23_1>
        <Screen30 v-if="screen === 92"></Screen30>
        <Screen31 v-if="screen === 93"></Screen31>
        <Screen32 v-if="screen === 94"></Screen32>
        <Screen33 v-if="screen === 95"></Screen33>
        <Screen34 v-if="screen === 96"></Screen34>
        <Screen35 v-if="screen === 97"></Screen35>
        <Screen36 v-if="screen === 98"></Screen36>
        <Screen37 v-if="screen === 99"></Screen37>
        <Screen38 v-if="screen === 101"></Screen38>
        <Screen39 v-if="screen === 102"></Screen39>
        <Screen40 v-if="screen === 103"></Screen40>
        <Screen41 v-if="screen === 104"></Screen41>
        <Screen42 v-if="screen === 105"></Screen42>
        <Screen43 v-if="screen === 106"></Screen43>
        <Screen44 v-if="screen === 107"></Screen44>
        <Screen45 v-if="screen === 108"></Screen45>
        <Screen46 v-if="screen === 109"></Screen46>
        <Screen47 v-if="screen === 110"></Screen47>
        <Screen48 v-if="screen === 111"></Screen48>
        <Screen49 v-if="screen === 112"></Screen49>
        <Screen50 v-if="screen === 113"></Screen50>
        <Screen51 v-if="screen === 114"></Screen51>
        <Screen52 v-if="screen === 115"></Screen52>
        <Screen53 v-if="screen === 116"></Screen53>
        <Screen54 v-if="screen === 117"></Screen54>
        <Screen55 v-if="screen === 118"></Screen55>
        <Screen56 v-if="screen === 119"></Screen56>
        <Screen57 v-if="screen === 120"></Screen57>
        <Screen58 v-if="screen === 121"></Screen58>
        <Screen59 v-if="screen === 122"></Screen59>
        <Screen60 v-if="screen === 123"></Screen60>
        <Screen61 v-if="screen === 124"></Screen61>

    </div>
</template>

<script>
  import IndexHdm from './components/IndexHdm.vue'
  import Screen1 from './components/Screen1.vue'
  import Screen1_1 from './components/Screen1_1.vue'
  import Screen23_1 from './components/Screen23_1.vue'
  import Screen2 from './components/Screen2.vue'
  import Screen_final from './components/Screen_final.vue'
  import Screen3 from './components/Screen3.vue'
  import Screen4 from './components/Screen4.vue'
  import Screen5 from './components/Screen5.vue'
  import Screen6 from './components/Screen6.vue'
  import Screen7 from './components/Screen7.vue'
  import Screen8 from './components/Screen8.vue'
  import Screen9 from './components/Screen9.vue'
  import Screen10 from './components/Screen10.vue'
  import Screen11 from './components/Screen11.vue'
  import Screen12 from './components/Screen12.vue'
  import Screen13 from './components/Screen13.vue'
  import Screen14 from './components/Screen14.vue'
  import Screen15 from './components/Screen15.vue'
  import Screen16 from './components/Screen16.vue'
  import Screen17 from './components/Screen17.vue'
  import Screen18 from './components/Screen18.vue'
  import Screen19 from './components/Screen19.vue'
  import Screen20 from './components/Screen20.vue'
  import Screen21 from './components/Screen21.vue'
  import Screen22 from './components/Screen22.vue'
  import Screen23 from './components/Screen23.vue'
  import Screen24 from './components/Screen24.vue'
  import Screen25 from './components/Screen25.vue'
  import Screen26 from './components/Screen26.vue'
  import Screen27 from './components/Screen27.vue'
  import Screen28 from './components/Screen28.vue'
  import Screen29 from './components/Screen29.vue'
  import Screen30 from './components/Screen30.vue'
  import Screen31 from './components/Screen31.vue'
  import Screen32 from './components/Screen32.vue'
  import Screen33 from './components/Screen33.vue'
  import Screen34 from './components/Screen34.vue'
  import Screen35 from './components/Screen35.vue'
  import Screen36 from './components/Screen36.vue'
  import Screen37 from './components/Screen37.vue'
  import Screen38 from './components/Screen38.vue'
  import Screen39 from './components/Screen39.vue'
  import Screen40 from './components/Screen40.vue'
  import Screen41 from './components/Screen41.vue'
  import Screen42 from './components/Screen42.vue'
  import Screen43 from './components/Screen43.vue'
  import Screen44 from './components/Screen44.vue'
  import Screen45 from './components/Screen45.vue'
  import Screen46 from './components/Screen46.vue'
  import Screen47 from './components/Screen47.vue'
  import Screen48 from './components/Screen48.vue'
  import Screen49 from './components/Screen49.vue'
  import Screen50 from './components/Screen50.vue'
  import Screen51 from './components/Screen51.vue'
  import Screen52 from './components/Screen52.vue'
  import Screen53 from './components/Screen53.vue'
  import Screen54 from './components/Screen54.vue'
  import Screen55 from './components/Screen55.vue'
  import Screen56 from './components/Screen56.vue'
  import Screen57 from './components/Screen57.vue'
  import Screen58 from './components/Screen58.vue'
  import Screen59 from './components/Screen59.vue'
  import Screen60 from './components/Screen60.vue'
  import Screen61 from './components/Screen61.vue'
  import ManagePartitions from './components/ManagePartitions.vue'
  import MP_screen1 from './components/MP_screen1.vue'
  import MP_screen2 from './components/MP_screen2.vue'
  import MP_screen3 from './components/MP_screen3.vue'
  import MP_screen4 from './components/MP_screen4.vue'
  import MP_screen5 from './components/MP_screen5.vue'
  import MP_screen6 from './components/MP_screen6.vue'
  import MP_screen7 from './components/MP_screen7.vue'
  import MP_screen8 from './components/MP_screen8.vue'
  import MP_screen9 from './components/MP_screen9.vue'
  import MP_screen10 from './components/MP_screen10.vue'
  import MP_screen11 from './components/MP_screen11.vue'
  import MP_screen12 from './components/MP_screen12.vue'
  import MP_screen13 from './components/MP_screen13.vue'
  import MP_screen14 from './components/MP_screen14.vue'
  import MP_screen15 from './components/MP_screen15.vue'
  import MP_screen16 from './components/MP_screen16.vue'
  import MP_screen17 from './components/MP_screen17.vue'
  import MP_screen18 from './components/MP_screen18.vue'
  import MP_screen19 from './components/MP_screen19.vue'
  import MP_screen20 from './components/MP_screen20.vue'
  import MP_screen21 from './components/MP_screen21.vue'
  import MP_screen22 from './components/MP_screen22.vue'
  import MD_screen1 from './components/MD_screen1.vue'
  import MD_screen2 from './components/MD_screen2.vue'
  import MD_screen3 from './components/MD_screen3.vue'
  import MD_screen4 from './components/MD_screen4.vue'
  import MD_screen5 from './components/MD_screen5.vue'
  import MD_screen6 from './components/MD_screen6.vue'
  import MD_screen7 from './components/MD_screen7.vue'
  import MD_screen8 from './components/MD_screen8.vue'
  import MD_screen9 from './components/MD_screen9.vue'
  import MD_screen10 from './components/MD_screen10.vue'
  import MD_screen11 from './components/MD_screen11.vue'
  import WS_screen1 from './components/WS_screen1.vue'
  import WS_screen2 from './components/WS_screen2.vue'
  import WS_screen3 from './components/WS_screen3.vue'
  import WS_screen4 from './components/WS_screen4.vue'
  import WS_screen5 from './components/WS_screen5.vue'
  import WS_screen6 from './components/WS_screen6.vue'
  import WS_screen7 from './components/WS_screen7.vue'
  import WS_screen8 from './components/WS_screen8.vue'
  import WS_screen9 from './components/WS_screen9.vue'
  import CD_screen1 from './components/CD_screen1.vue'
  import CD_screen2 from './components/CD_screen2.vue'
  import CD_screen3 from './components/CD_screen3.vue'
  import CD_screen4 from './components/CD_screen4.vue'
  import CD_screen5 from './components/CD_screen5.vue'
  import CD_screen6 from './components/CD_screen6.vue'
  import CD_screen7 from './components/CD_screen7.vue'
  import CD_screen8 from './components/CD_screen8.vue'
  import CD_screen9 from './components/CD_screen9.vue'
  import CD_screen10 from './components/CD_screen10.vue'
  import CD_screen11 from './components/CD_screen11.vue'
  import CD_screen12 from './components/CD_screen12.vue'
  import CD_screen13 from './components/CD_screen13.vue'
  import CD_screen14 from './components/CD_screen14.vue'
  import CD_screen15 from './components/CD_screen15.vue'
  import CD_screen16 from './components/CD_screen16.vue'

  import { mapGetters } from 'vuex'
  import MigrateDataOS from "./components/MigrateDataOS"; // Подключаем хелпер
  export default {
    computed: {
      ...mapGetters({
        screen: 'getScreen'
      })
    },
    data() {
      return {
      };
    },
    components: {
      MigrateDataOS,
      IndexHdm,
      Screen1,
      Screen1_1,
      Screen23_1,
      Screen2,
      Screen_final,
      Screen3,
      Screen4,
      Screen5,
      Screen6,
      Screen7,
      Screen8,
      Screen9,
      Screen10,
      Screen11,
      Screen12,
      Screen13,
      Screen14,
      Screen15,
      Screen16,
      Screen17,
      Screen18,
      Screen19,
      Screen20,
      Screen21,
      Screen22,
      Screen23,
      Screen24,
      Screen25,
      Screen26,
      Screen27,
      Screen28,
      Screen29,
      Screen30,
      Screen31,
      Screen32,
      Screen33,
      Screen34,
      Screen35,
      Screen36,
      Screen37,
      Screen38,
      Screen39,
      Screen40,
      Screen41,
      Screen42,
      Screen43,
      Screen44,
      Screen45,
      Screen46,
      Screen47,
      Screen48,
      Screen49,
      Screen50,
      Screen51,
      Screen52,
      Screen53,
      Screen54,
      Screen55,
      Screen56,
      Screen57,
      Screen58,
      Screen59,
      Screen60,
      Screen61,
      ManagePartitions,
      MP_screen1,
      MP_screen2,
      MP_screen3,
      MP_screen4,
      MP_screen5,
      MP_screen6,
      MP_screen7,
      MP_screen8,
      MP_screen9,
      MP_screen10,
      MP_screen11,
      MP_screen12,
      MP_screen13,
      MP_screen14,
      MP_screen15,
      MP_screen16,
      MP_screen17,
      MP_screen18,
      MP_screen19,
      MP_screen20,
      MP_screen21,
      MP_screen22,
      MD_screen1,
      MD_screen2,
      MD_screen3,
      MD_screen4,
      MD_screen5,
      MD_screen6,
      MD_screen7,
      MD_screen8,
      MD_screen9,
      MD_screen10,
      MD_screen11,
      WS_screen1,
      WS_screen2,
      WS_screen3,
      WS_screen4,
      WS_screen5,
      WS_screen6,
      WS_screen7,
      WS_screen8,
      WS_screen9,
      CD_screen1,
      CD_screen2,
      CD_screen3,
      CD_screen4,
      CD_screen5,
      CD_screen6,
      CD_screen7,
      CD_screen8,
      CD_screen9,
      CD_screen10,
      CD_screen11,
      CD_screen12,
      CD_screen13,
      CD_screen14,
      CD_screen15,
      CD_screen16,

    }
  }
</script>
